import { api } from "@/utils/api";
import { sanitizePathParam } from "@/utils/sanitize";

export default class HydraulicSimulatorRepository {
  async postInpAssets(file: string, name: string, others: any): Promise<any> {
    const response = await api.post(`/mms/upload`, { fileName: name, ...others });
    return response.data;
  }

  async getAssetsFromMmsid(mmsId: string, locationId: number) {
    const mid = sanitizePathParam(mmsId);
    const response = await api.get(`mms/${mid}`, {
      params: {
        locationId
      }
    });

    return response.data;
  }

  async getAttributesFromAsset(mmsId: string, assetId: string, type: string, locationId: number) {  
    const mid = sanitizePathParam(mmsId);
    const aid = sanitizePathParam(assetId);
    const t = sanitizePathParam(type);
    const response = await api.get(
      `mms/${mid}/assets/${aid}/type/${t}/details`,
      {
        params: {
          locationId
        }
      }
    );
    return response.data;
    return response.data;
    // return {
    //   assetId: "TANK_003",
    //   assetType: "NODE",
    //   type: "STORAGE",
    //   coordinates: [[41.68043393728247, -86.25448354881955]],
    //   attributes: [
    //     {
    //       name: "depth",
    //       value: "30",
    //       editable: true,
    //       numeric: true,
    //       ranges: [4, null],
    //       options: [],
    //     },
    //     {
    //       name: "depth2",
    //       value: "30",
    //       editable: true,
    //       numeric: false,
    //       ranges: [],
    //       options: ["30", "40", "50"],
    //     },
    //   ],
    //   edited: false,
    //   invisible: false,
    // };
  }

  async postSaveChangesModelFile(mmsId: string, data: any, locationId: number) {
    const mid = sanitizePathParam(mmsId);
    const response = await api.post(`mms/${mid}/changes`, data, {
      params: {
        locationId
      }
    });
    return response.data;
  }
}
